module.exports = __webpack_public_path__ + "gh.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gh.svg
// module id = 566
// module chunks = 0